import {
    apiRequest,
    PNSdetailPNS,
} from "../../../../../services/adapters/kepegawaian/DokumenPNSService"

class DetailRepository {


    fetchDetail = async (query) => {
        return await apiRequest("get", PNSdetailPNS, {
            params: query
        }, true)
    }
}

export default DetailRepository